export default "__VITE_ASSET__BL6QH2Mi__"